import {Workspace, WSModes} from "../types/Workspace";
import get from 'lodash.get'

export const hasWSMode = (ws: Workspace, mode: WSModes): boolean => {
  return (get(ws, 'params.modes', []) as WSModes[]).includes(mode)
}